
import './skills.css'
import html from '../image/html.jpg'
import react from '../image/react.png'
import css from '../image/css.png'
import mongo from '../image/mongo.png'
import nodejs from '../image/nodejs.png'
import javascript from '../image/javascript.png'
import git from '../image/git.png'
import redux from '../image/redux.jpg'
import React, { useContext } from "react";
import { themeContext } from "../../Context";
export const Skills = () => {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  return (
    <div className="skills">
         <div className="awesome" id="skills">
        {/* dark mode */}
        <span  style={{ color: darkMode ? "white" : "" }}>My Skills</span>
        <span>Some of them are:</span>
        <span >
      <span style={{fontSize:'17px',fontWeight:'600'}}>
      <br />
          HTML5
         
          CSS3
          <br />
          Javascript
          <br />
          ReactJs
          <br />
          Redux
          <br />
          MongoDb
          <br />
          NodeJs
          <br />
          ExpressJs
          <br />
          TypeScript
          <br />
          GraphQL
          <br />
      </span>
        </span>

        <div className="blur s-blur1" style={{ background: "#ABF1FF94" }}></div>
      </div>
   
          <div className='cards'>
         <div className="in-cards"> <img  className='img'src={html} alt="" /> <h5>HTML</h5></div>
         <div className="in-cards"><img  className='img'src={css} alt="" /><h5>CSS</h5></div> 
         <div className="in-cards"><img  className='img'src={javascript} alt="" /> <h5>javascript</h5> </div> 
         <div className="in-cards"><img  className='img'src={mongo} alt="" /> <h5>mongoDb</h5> </div> 
         <div className="in-cards"><img  className='img'src={react} alt="" /> <h5>react</h5> </div> 
        <div className="in-cards"> <img  className='img'src={nodejs} alt="" /> <h5>nodejs</h5> </div> 
        <div className="in-cards"> <img  className='img'src={git} alt="" /> <h5>gitHub</h5> </div> 
        <div className="in-cards"> <img  className='img'src={redux} alt="" /> <h5>redux</h5> </div> 
          </div>
   
      
    </div>
  )
}
